import { render, staticRenderFns } from "./AddVideo.vue?vue&type=template&id=3cac5c98&scoped=true&"
import script from "./AddVideo.vue?vue&type=script&lang=js&"
export * from "./AddVideo.vue?vue&type=script&lang=js&"
import style0 from "./AddVideo.vue?vue&type=style&index=0&id=3cac5c98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac5c98",
  null
  
)

component.options.__file = "AddVideo.vue"
export default component.exports